module.exports = __webpack_public_path__ + "static/media/11d.c6eecffc.svg";